import { Helmet } from 'react-helmet'
import {PhoneLink} from '../../components/Shared/Links'
import menuLink from '../../ThanksgivingMenu.pdf'
import menuImage from '../../assets/images/menuThanksgiving.png'

export default function Thanksgiving(){
  return (
    <div className="pageStyles thanksgivingPage">
      <Helmet>
        <title>Thanksgiving Meals To Go in Orange Beach, AL</title>
        <meta name="description" content="Let Villaggio provide the meal for your family's Thanksgiving celebration this year!" />
      </Helmet>

      <div className="simpleBanner">
        <div className="bannerWrap med3Def">
          <h2>Leave the Cooking to Us</h2>
          <h1>Thanksgiving Meals<br/> To Go</h1>
          <h3>$120 Per Meal <span>&middot;</span> Feeds 4 People</h3>
          <ul>
            <li className="li1"><b>1. </b>Call to Order:<br class="br1" /> <span><PhoneLink /></span></li>
            <li className="li2"><b>2. </b>Select Pick Up Time:<br class="br2" /> <span>11am, 12pm, 1pm, 2pm</span></li>
            <li className="li3"><b>3. </b>Celebrate<br class="br3" /> <span>&amp; Enjoy!</span></li>
          </ul>
        </div>
      </div>

      <div className="page-content textCenter">
        <div className="medDef food-menus no-padding">
          <p className="instr">Click image below to view/download</p>
          <a href={menuLink} target="_blank" rel="noopener noreferrer" className="menu-item menuImg">
            <img src={menuImage} alt="Villaggio Lunch Menu, Orange Beach, AL restaurant" className="border" />
          </a>
        </div>
      </div>

      <div className="col-xs-12"><div className="hr hr-png-1"></div></div>
    </div>
  )
}
